var React = require('react');

function Google (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.875 11.8969C22.875 18.5297 18.3328 23.25 11.625 23.25C5.19375 23.25 0 18.0562 0 11.625C0 5.19375 5.19375 0 11.625 0C14.7563 0 17.3906 1.14844 19.4203 3.04219L16.2562 6.08438C12.1172 2.09063 4.42031 5.09063 4.42031 11.625C4.42031 15.6797 7.65938 18.9656 11.625 18.9656C16.2281 18.9656 17.9531 15.6656 18.225 13.9547H11.625V9.95625H22.6922C22.8 10.5516 22.875 11.1234 22.875 11.8969Z","fill":"black"}));
}

Google.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Google;

Google.default = Google;
